// react
import React from 'react'

// external libs
import { Grid } from '@material-ui/core'

// components
import MyAccordion from '../../../../control/accordion/accordion'
import MyDatePicker from '../../../../control/datepicker/datepicker'
import MyTextfield from '../../../../control/textfield/textfield'

// hooks
import useSiteVisitDetail from './useSiteVisitDetail'

// types
import type { SiteVisitDetailType, SiteVisitDetailViewType } from './siteVisitDetailType'

const SiteVisitDetailView: React.FC<SiteVisitDetailViewType> = ({ ...props }) => {
    const { hideAccordion = false, disabled } = props

    const renderElement = () => (
        <Grid container spacing={4}>
            <Grid container item justify="flex-start" spacing={2}>
                <Grid item xs={12} md={6} lg={6}>
                    <MyDatePicker name="siteVisitDate" label="วันที่ตรวจเยี่ยม" required disabled={disabled} />
                </Grid>

                <Grid item xs={12} md={12} lg={12}>
                    <MyTextfield
                        name={`siteVisitRemark`}
                        materialInputProps={{
                            label: 'หมายเหตุ',
                            placeholder: 'กรอกหมายเหตุ',
                            size: 'small',
                            rows: 2,
                            multiline: true,
                            disabled: disabled,
                        }}
                        maxLength={1000}
                    />
                </Grid>
            </Grid>
        </Grid>
    )

    return (
        <>
            {hideAccordion ? renderElement() : <MyAccordion title="รายงานการตรวจเยี่ยม">{renderElement()}</MyAccordion>}
        </>
    )
}

const SiteVisitDetail: React.FC<SiteVisitDetailType> = ({ ...props }) => {
    const researchDetailModel = useSiteVisitDetail({ ...props })
    return <SiteVisitDetailView {...researchDetailModel} {...props} />
}

export default SiteVisitDetail
